module.exports = __webpack_public_path__ + "media/images/pages/i-belong/i_belong_poster_template-b266b9304a85c547417976019af030a0.svg";